export default __webpack_public_path__ + "static/media/login-leaf.88811693.svg";